import {createContext, useState} from 'react'

export const Context = createContext(null);

export const TpsContext = ({children}) => { 

    const [tpsContext, setTpsContext] = useState({
        suppliers:[], 
        answers:[],
        assignments:[],
        errors:[], 
        country:null,
        parts:[],
        campaignId:null,
        tpsResponseSelected:null,
        responseName:null
    })
    
    return <Context.Provider  value={{
        tpsContext,
        setTpsContext,
    }}>
        {children}
    </Context.Provider>
}